export const SET_JOURNAL_TABLE_FILTER = 'SET_JOURNAL_TABLE_FILTER';
export const UNSET_JOURNAL_TABLE_FILTER = 'UNSET_JOURNAL_TABLE_FILTER';
